export default "__VITE_ASSET__CmS6YLPG__"